import { Playlist } from './playlist/playlist'

export class TimeslotContent {
	public id: number
	public timeslotId: number
	public type: string
	public metadata: TimeslotContentMetadata
	public playlists?: Playlist[]

	constructor(data: {
		id: number
		timeslotId: number
		type: string
		metadata: TimeslotContentMetadata
		playlists?: Playlist[]
	}) {
		this.id = data.id
		this.timeslotId = data.timeslotId
		this.type = data.type
		this.metadata = data.metadata
		this.playlists = data.playlists
	}

	static create(data: Partial<TimeslotContent>): TimeslotContent {
		const defaultData = {
			id: 0,
			timeslotId: 0,
			type: '',
			metadata: TimeslotContentMetadata.create({
				volume: 0,
			}),
			playlists: [],
		}

		return new TimeslotContent({
			...defaultData,
			...data,
		})
	}
}

export class TimeslotContentMetadata {
	public volume: number
	public minPercentage?: number
	public maxPercentage?: number

	constructor(data: {
		volume: number
		minPercentage?: number
		maxPercentage?: number
	}) {
		this.volume = data.volume
		this.minPercentage = data.minPercentage
		this.maxPercentage = data.maxPercentage
	}

	static create(
		data: Partial<TimeslotContentMetadata>
	): TimeslotContentMetadata {
		const defaultData = {
			volume: 0,
		}

		return new TimeslotContentMetadata({
			...defaultData,
			...data,
		})
	}
}
